export function toDatabase(number) {
  if (!number) return '';
  return parseFloat(
    number
      .replace(/[^0-9.,]+/, '')
      .replace('.', '')
      .replace(',', '.')
  );
}

export function removeNonDigits(text) {
  if (!text) return '';

  return text.replace(/[^0-9]/g, '');
}
